export default __webpack_public_path__ + "static/multiple-accounts-m-6f1f5bdf52afcac1f11669a84073684e.webp";